import { Card } from "./ui/card";
import Countdown from "./Countdown";
import { Rocket } from "lucide-react";
import { LAUNCH_DATE_ISO, LAUNCH_DATE_LABEL } from "../lib/api";

export const LaunchBanner = () => (
  <Card className="p-5 mb-6 gold-border flex flex-col md:flex-row md:items-center justify-between gap-4" data-testid="launch-banner">
    <div className="flex items-center gap-3">
      <Rocket className="h-6 w-6 text-amber-400 shrink-0" />
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Pré-lançamento</div>
        <div className="font-display text-lg font-bold">
          Lançamento oficial: <span className="gold-text" data-testid="launch-date">{LAUNCH_DATE_LABEL}</span>
        </div>
      </div>
    </div>
    <div className="w-full md:w-auto md:min-w-[320px]"><Countdown targetIso={LAUNCH_DATE_ISO} /></div>
  </Card>
);
